import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    Button,
    Card,
    Divider,
    Flex,
    Text,
    Title,
} from '@tremor/react'
import { useState } from 'react'
import { ChevronDoubleDownIcon } from '@heroicons/react/24/outline'
import type { Labels, Recommendation } from './types'
import { currency } from './utils'

interface Props {
    recs: Recommendation[]
    total: number
    labels: Labels
}

export default function Results({ recs, total, labels }: Props) {
    const [show, setShow] = useState(false)

    return (
        <>
            <Card className="bg-teal-800 ring-teal-900">
                <Flex justifyContent="between" alignItems="center">
                    <Title className="text-2xl text-white">
                        Total estimated savings
                    </Title>
                    <Title className="text-3xl font-semibold text-teal-50">
                        {currency(total)}
                    </Title>
                </Flex>
            </Card>
            <Card
                className={`bg-teal-800 ring-teal-900 ${
                    show ? '' : 'cursor-pointer'
                }`}
                onClick={() => setShow(true)}
            >
                <Flex
                    flexDirection="row"
                    justifyContent="between"
                    alignItems="center"
                >
                    <Title className="text-white">
                        {show
                            ? 'Recommendations'
                            : 'Click to show recommendations'}
                    </Title>
                    {!show && (
                        <ChevronDoubleDownIcon className="w-6 h-6 text-white" />
                    )}
                </Flex>
                {show &&
                    (recs.length === 0 ? (
                        <Text className="text-gray-600">
                            Fill out inputs and click Analyze to see guidance.
                        </Text>
                    ) : (
                        <Flex flexDirection="col" className="space-y-3 mt-4">
                            {recs.map((r) => (
                                <Card
                                    key={r.id}
                                    className="border bg-teal-700 ring-teal-800 shadow-0 border-0"
                                >
                                    <Title className="text-base text-white">
                                        {r.title}
                                    </Title>
                                    <Text className="mt-1 text-white">
                                        {r.detail}
                                    </Text>
                                    {r.estimatedMonthlySavings !==
                                        undefined && (
                                        <Text className="mt-2 font-semibold text-teal-300">
                                            Est. savings:{' '}
                                            {currency(
                                                r.estimatedMonthlySavings
                                            )}
                                        </Text>
                                    )}
                                </Card>
                            ))}
                        </Flex>
                    ))}
            </Card>
        </>
    )
}
